document.querySelectorAll('.faq-q').forEach(btn=>btn.addEventListener('click',()=>{
  const isOpen=btn.parentElement.classList.toggle('open');
  btn.setAttribute('aria-expanded',String(isOpen));
}));
const showBtn=document.getElementById('showAviss');
showBtn?.addEventListener('click',()=>{
  document.querySelectorAll('.review-card.hidden').forEach(el=>el.classList.remove('hidden'));
  showBtn.style.display='none';
});




const productThumbs = [...document.querySelectorAll('.product-thumbnails .thumb')];
const productMain = document.querySelector('.product-main-img');
let currentProductImage = 0;
let productImageRequest = 0;

function showProductImage(index){
  if(!productThumbs.length || !productMain) return;
  const nextIndex=(index+productThumbs.length)%productThumbs.length;
  if(nextIndex===currentProductImage && productMain.src) return;

  const nextImg=productThumbs[nextIndex]?.querySelector('img');
  if(!nextImg) return;

  const request=++productImageRequest;
  const target=productThumbs[nextIndex]?.dataset.gallerySrc || nextImg.src;
  const preload=new Image();
  preload.onload=()=>{
    if(request!==productImageRequest) return;
    currentProductImage=nextIndex;
    productThumbs.forEach((item,i)=>item.classList.toggle('active',i===currentProductImage));
    productMain.removeAttribute('srcset');
    productMain.removeAttribute('sizes');
    productMain.src=target;
  };
  preload.src=target;
}
productThumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>showProductImage(index)));
document.querySelector('.gallery-prev')?.addEventListener('click',()=>showProductImage(currentProductImage-1));
document.querySelector('.gallery-next')?.addEventListener('click',()=>showProductImage(currentProductImage+1));

const recommendationTrack = document.querySelector('[data-recommendation-track]');
function scrollRecommendations(direction){
  if(!recommendationTrack) return;
  const card = recommendationTrack.querySelector('.mini-product');
  recommendationTrack.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || 320) + 18), behavior: 'smooth' });
}
document.querySelector('[data-recommendation-prev]')?.addEventListener('click',()=>scrollRecommendations(-1));
document.querySelector('[data-recommendation-next]')?.addEventListener('click',()=>scrollRecommendations(1));

const setupTrack = document.querySelector('[data-setup-track]');
const setupDots = [...document.querySelectorAll('[data-setup-dot]')];
const setupPrev = document.querySelector('[data-setup-prev]');
const setupNext = document.querySelector('[data-setup-next]');
function updateSetupControls(index = currentSetupIndex()){
  const lastIndex = Math.max(0, setupDots.length - 1);
  setupDots.forEach((dot,dotIndex)=>dot.classList.toggle('is-active',dotIndex===index));
  if(setupPrev) setupPrev.hidden = index <= 0;
  if(setupNext) setupNext.hidden = index >= lastIndex;
}
function updateSetupCarousel(index){
  if(!setupTrack) return;
  const cards = [...setupTrack.querySelectorAll('.premium-setup-card')];
  const nextIndex = Math.max(0, Math.min(index, cards.length - 1));
  const target = cards[nextIndex];
  if(target){
    const left = target.offsetLeft - (setupTrack.clientWidth - target.offsetWidth) / 2;
    setupTrack.scrollTo({left:Math.max(0,left),behavior:'smooth'});
    updateSetupControls(nextIndex);
  }
}
function currentSetupIndex(){
  if(!setupTrack) return 0;
  const cards = [...setupTrack.querySelectorAll('.premium-setup-card')];
  const center = setupTrack.scrollLeft + setupTrack.clientWidth / 2;
  let closest = 0;
  let distance = Infinity;
  cards.forEach((card,index)=>{
    const cardCenter = card.offsetLeft + card.offsetWidth / 2;
    if(Math.abs(cardCenter - center) < distance){ distance = Math.abs(cardCenter - center); closest = index; }
  });
  return closest;
}
let setupScrollFrame = 0;
setupTrack?.addEventListener('scroll',()=>{
  if(setupScrollFrame) cancelAnimationFrame(setupScrollFrame);
  setupScrollFrame = requestAnimationFrame(()=>{
    updateSetupControls();
  });
},{passive:true});
setupPrev?.addEventListener('click',()=>updateSetupCarousel(currentSetupIndex()-1));
setupNext?.addEventListener('click',()=>updateSetupCarousel(currentSetupIndex()+1));
setupDots.forEach((dot,index)=>dot.addEventListener('click',()=>updateSetupCarousel(index)));
updateSetupControls(0);
window.addEventListener('resize',()=>updateSetupControls(),{passive:true});

const lazyVideos = [...document.querySelectorAll('[data-lazy-video]')];
const activateVideo = video => {
  if(video.dataset.loaded === 'true') return;
  video.querySelectorAll('source[data-src]').forEach(source => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });
  video.dataset.loaded = 'true';
  video.load();
  video.play().catch(()=>{});
};
if('IntersectionObserver' in window){
  const videoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        activateVideo(entry.target);
        entry.target.play().catch(()=>{});
      }else if(entry.target.dataset.loaded === 'true'){
        entry.target.pause();
      }
    });
  },{rootMargin:'320px 0px'});
  lazyVideos.forEach(video=>videoObserver.observe(video));
}else{
  lazyVideos.forEach(activateVideo);
}

const bundleRewardStyle=document.createElement('style');
bundleRewardStyle.textContent='.tt-bundle-reward{display:flex;align-items:center;justify-content:center;gap:7px;margin:10px 0 2px;padding:9px 12px;border:1px solid rgba(35,126,255,.34);border-radius:10px;background:linear-gradient(135deg,rgba(235,246,255,.96),rgba(255,255,255,.98));box-shadow:0 8px 22px rgba(22,104,225,.10);color:#0b4da6;font-size:13px;font-weight:700;line-height:1.25;text-align:center;opacity:0;transform:translateY(-4px);max-height:0;overflow:hidden;padding-top:0;padding-bottom:0;margin-top:0;transition:opacity .2s ease,transform .2s ease,max-height .24s ease,padding .24s ease,margin .24s ease}.tt-bundle-reward.is-visible{opacity:1;transform:none;max-height:72px;padding-top:9px;padding-bottom:9px;margin-top:10px}.tt-bundle-confetti{position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999}@media(prefers-reduced-motion:reduce){.tt-bundle-reward{transition:none}}';
document.head.appendChild(bundleRewardStyle);
const bundleOfferList=document.querySelector('[data-product-offers]');
const bundleReward=document.createElement('div');
bundleReward.className='tt-bundle-reward';
bundleReward.setAttribute('role','status');
bundleReward.setAttribute('aria-live','polite');
bundleReward.textContent=document.documentElement.lang.toLowerCase().startsWith('en')?'🎉 You unlocked our best offer: 36% off + free shipping':'🎉 Vous débloquez notre meilleure offre : 36 % d’économie + livraison gratuite';
bundleOfferList?.insertAdjacentElement('afterend',bundleReward);

function playBundleConfetti(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try{if(sessionStorage.getItem('trusttap-best-bundle-rewarded')==='1') return;sessionStorage.setItem('trusttap-best-bundle-rewarded','1')}catch(error){}
  const canvas=document.createElement('canvas');
  canvas.className='tt-bundle-confetti';
  canvas.setAttribute('aria-hidden','true');
  document.body.appendChild(canvas);
  const context=canvas.getContext('2d');
  const ratio=Math.min(window.devicePixelRatio||1,2);
  const width=window.innerWidth,height=window.innerHeight;
  canvas.width=width*ratio;canvas.height=height*ratio;context.scale(ratio,ratio);
  const colors=['#0b6cff','#4fa3ff','#9dd3ff','#ffffff','#f6c453'];
  const pieces=Array.from({length:56},(_,index)=>({x:width*(.34+Math.random()*.32),y:height*.44,vx:(Math.random()-.5)*8,vy:-5-Math.random()*7,g:.19+Math.random()*.08,w:5+Math.random()*5,h:3+Math.random()*4,r:Math.random()*Math.PI,color:colors[index%colors.length],spin:(Math.random()-.5)*.24}));
  const started=performance.now();
  function frame(now){
    context.clearRect(0,0,width,height);
    pieces.forEach(piece=>{piece.x+=piece.vx;piece.y+=piece.vy;piece.vy+=piece.g;piece.r+=piece.spin;context.save();context.translate(piece.x,piece.y);context.rotate(piece.r);context.fillStyle=piece.color;context.fillRect(-piece.w/2,-piece.h/2,piece.w,piece.h);context.restore()});
    if(now-started<900) requestAnimationFrame(frame); else canvas.remove();
  }
  requestAnimationFrame(frame);
}

document.querySelectorAll('.offer-option').forEach(option=>{
  option.addEventListener('click',()=>{
    document.querySelectorAll('.offer-option').forEach(item=>item.classList.remove('active'));
    option.classList.add('active');
    const price=option.getAttribute('data-price');
    const priceTarget=document.getElementById('selectedPrice');
    if(priceTarget && price) priceTarget.textContent=price;
    const comparePrice=option.getAttribute('data-compare-price');
    const compareTarget=document.getElementById('selectedComparePrice');
    if(compareTarget){compareTarget.textContent=comparePrice || '';compareTarget.hidden=!comparePrice;}
    const isBestBundle=Boolean(option.querySelector('.offer-product-preview.five'));
    bundleReward?.classList.toggle('is-visible',isBestBundle);
    if(isBestBundle) playBundleConfetti();
  });
});

const platformItems = [...document.querySelectorAll('.platform-item')];
const platformRotator = document.querySelector('.platform-rotator');
let platformIndex = 0;

function showNextPlatform(){
  if(platformItems.length < 2 || !platformRotator) return;
  const current = platformItems[platformIndex];
  current.classList.remove('is-active');
  current.classList.add('is-leaving');

  platformIndex = (platformIndex + 1) % platformItems.length;
  const next = platformItems[platformIndex];
  const targetWidth = Number(next.dataset.width || 156);
  platformRotator.style.width = targetWidth + 'px';

  setTimeout(()=>{
    current.classList.remove('is-leaving');
    next.classList.add('is-active');
  }, 120);
}
setInterval(showNextPlatform, 2600);

const mobileMenuButton = document.getElementById('mobileMenuButton');
const mobileNavPanel = document.getElementById('mobileNavPanel');
mobileMenuButton?.addEventListener('click',()=>{
  const isOpen = mobileNavPanel?.classList.toggle('open');
  mobileMenuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});
mobileNavPanel?.querySelectorAll('a').forEach(link=>{
  link.addEventListener('click',()=>{
    mobileNavPanel.classList.remove('open');
    mobileMenuButton?.setAttribute('aria-expanded','false');
  });
});
document.addEventListener('click',(event)=>{
  if(!mobileNavPanel || !mobileMenuButton) return;
  if(!mobileNavPanel.contains(event.target) && !mobileMenuButton.contains(event.target)){
    mobileNavPanel.classList.remove('open');
    mobileMenuButton.setAttribute('aria-expanded','false');
  }
});


const marketSlides = [...document.querySelectorAll('.market-slide')];
const marketDots = [...document.querySelectorAll('.market-dot')];
const marketProgressFill = document.getElementById('marketProgressFill');
let marketIndex = 0;
let marketTimer = null;

function animateMarketProgress(){
  if(!marketProgressFill) return;
  marketProgressFill.style.transition = 'none';
  marketProgressFill.style.width = '0%';
  requestAnimationFrame(()=>{
    requestAnimationFrame(()=>{
      marketProgressFill.style.transition = 'width 3000ms linear';
      marketProgressFill.style.width = '100%';
    });
  });
}

function showMarketSlide(index){
  if(!marketSlides.length) return;
  marketIndex = (index + marketSlides.length) % marketSlides.length;
  marketSlides.forEach((slide,i)=>slide.classList.toggle('active',i===marketIndex));
  marketDots.forEach((dot,i)=>dot.classList.toggle('active',i===marketIndex));
  animateMarketProgress();
}

function startMarketCarousel(){
  clearInterval(marketTimer);
  animateMarketProgress();
  marketTimer = setInterval(()=>showMarketSlide(marketIndex+1),3000);
}

marketDots.forEach((dot,index)=>{
  dot.addEventListener('click',()=>{
    showMarketSlide(index);
    startMarketCarousel();
  });
});

showMarketSlide(0);
startMarketCarousel();


const marketGridTrack = document.getElementById('marketGridTrack');
const marketMobileDots = [...document.querySelectorAll('.market-mobile-dot')];
let marketMobilePage = 0;
let marketMobileTimer = null;

function updateMarketMobile(page){
  if(!marketGridTrack) return;
  marketMobilePage = ((page % 2) + 2) % 2;
  const offset = marketMobilePage === 0 ? 0 : -100;
  marketGridTrack.style.transform = `translateX(${offset}%)`;
  marketMobileDots.forEach((dot,i)=>dot.classList.toggle('active',i===marketMobilePage));
}

function startMarketMobile(){
  clearInterval(marketMobileTimer);
  if(window.innerWidth <= 980){
    marketMobileTimer = setInterval(()=>updateMarketMobile(marketMobilePage+1),3000);
  }else{
    updateMarketMobile(0);
    marketGridTrack && (marketGridTrack.style.transform='none');
  }
}

marketMobileDots.forEach((dot,index)=>{
  dot.addEventListener('click',()=>{
    updateMarketMobile(index);
    startMarketMobile();
  });
});

window.addEventListener('resize', startMarketMobile);
startMarketMobile();

const trustTapRoot = document.querySelector('[data-trusttap-section]');
if (trustTapRoot) {
  const isEnglishLanding = trustTapRoot.getAttribute('lang')?.toLowerCase().startsWith('en');
  const drawer = trustTapRoot.querySelector('[data-cart-drawer]');
  const overlay = trustTapRoot.querySelector('[data-cart-overlay]');
  const itemsTarget = trustTapRoot.querySelector('[data-cart-items]');
  const totalTarget = trustTapRoot.querySelector('[data-cart-total]');
  const footerTarget = trustTapRoot.querySelector('[data-cart-footer]');
  const countTargets = trustTapRoot.querySelectorAll('[data-cart-count]');
  const money = value => new Intl.NumberFormat(isEnglishLanding ? 'en-CA' : 'fr-CA', { style: 'currency', currency: window.Shopify?.currency?.active || 'CAD' }).format(value / 100);
  const localizedCartPath = path => window.TrustTapCartPath ? window.TrustTapCartPath(path) : `${(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;

  async function refreshCart() {
    const response = await fetch(localizedCartPath('cart.js'), { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    itemsTarget.innerHTML = cart.items.length ? cart.items.map(item => { const properties = Object.entries(item.properties || {}).filter(([key,value]) => key.charAt(0) !== '_' && value).map(([key,value]) => '<small class="trusttap-cart-property"><b>' + key + ' :</b> ' + value + '</small>').join(''); return '<article class="trusttap-cart-line"><img src="' + (item.image || '') + '" alt=""><div class="trusttap-cart-copy"><strong>' + item.product_title + '</strong><small>' + (item.variant_title || '') + '</small>' + properties + '<span>' + money(item.final_line_price) + '</span><div class="trusttap-cart-controls"><button type="button" data-cart-key="' + item.key + '" data-cart-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Diminuer">−</button><span>' + item.quantity + '</span><button type="button" data-cart-key="' + item.key + '" data-cart-quantity="' + (item.quantity + 1) + '" aria-label="Augmenter">+</button><button class="trusttap-cart-remove" type="button" data-cart-key="' + item.key + '" data-cart-quantity="0">Retirer</button></div></div></article>'; }).join('') : '<p>Votre panier est vide.</p>';
    totalTarget.textContent = money(cart.total_price);
    footerTarget.hidden = !cart.items.length;
    countTargets.forEach(target => {
      target.textContent = cart.item_count;
      target.hidden = cart.item_count === 0;
    });
    trustTapRoot.querySelectorAll('[data-cart-open]').forEach(button => button.setAttribute('aria-label', 'Panier, ' + cart.item_count + ' article' + (cart.item_count === 1 ? '' : 's')));
  }

  async function openCart() {
    if (window.TrustTapCart?.open) {
      await window.TrustTapCart.open();
      return;
    }
    document.querySelector('[data-site-cart-open]')?.click();
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('trusttap-cart-open');
  }

  trustTapRoot.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
  trustTapRoot.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  itemsTarget?.addEventListener('click', async event => {
    const control = event.target.closest('[data-cart-key]');
    if (!control) return;
    control.disabled = true;
    try {
      const response = await fetch(localizedCartPath('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: control.dataset.cartKey, quantity: Number(control.dataset.cartQuantity) }) });
      if (!response.ok) throw new Error(isEnglishLanding ? 'Unable to update your cart.' : 'Impossible de modifier le panier.');
      await refreshCart();
    } catch (error) {
      window.alert(error.message);
      control.disabled = false;
    }
  });

  async function addVariant(variantId, button, quantity = 1, includeLanguage = false) {
    if (!variantId) return;
    const oldHtml = button.innerHTML;
    button.disabled = true;
    button.textContent = isEnglishLanding ? 'ADDING…' : 'AJOUT…';
    try {
      const item = { id: Number(variantId), quantity: Number(quantity), properties: isEnglishLanding ? { 'TrustTap offer': 'Promotional price already applied' } : { 'Offre TrustTap': 'Prix promotionnel déjà appliqué' } };
      if (includeLanguage) item.properties[isEnglishLanding ? 'Printed language' : 'Langue imprimée'] = trustTapRoot.querySelector('[data-homepage-language]:checked')?.value || (isEnglishLanding ? 'English' : 'Français');
      await window.TrustTapAddItems([item]);
      await openCart();
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
      button.innerHTML = oldHtml;
    }
  }

  trustTapRoot.querySelector('[data-add-to-cart]')?.addEventListener('click', event => {
    const selected = trustTapRoot.querySelector('.offer-option.active[data-variant-id]');
    addVariant(selected?.dataset.variantId, event.currentTarget, selected?.dataset.quantity || 1, true);
  });
  trustTapRoot.querySelectorAll('[data-upsell-add][data-variant-id]').forEach(button => button.addEventListener('click', event => addVariant(event.currentTarget.dataset.variantId, event.currentTarget)));
  trustTapRoot.querySelectorAll('[data-card-add][data-variant-id]').forEach(button => button.addEventListener('click', event => addVariant(event.currentTarget.dataset.variantId, event.currentTarget, 1, event.currentTarget.hasAttribute('data-requires-language'))));
  const reviewModal = trustTapRoot.querySelector('[data-review-modal]');
  const closeReview = () => { if (!reviewModal) return; reviewModal.hidden = true; document.body.classList.remove('trusttap-review-open'); };
  trustTapRoot.querySelectorAll('[data-review-name]').forEach(card => card.addEventListener('click', () => {
    if (!reviewModal) return;
    reviewModal.querySelector('[data-review-modal-image]').src = card.dataset.reviewImage || '';
    reviewModal.querySelector('[data-review-modal-image]').alt = 'Photo de l’avis de ' + (card.dataset.reviewName || 'client TrustTap');
    reviewModal.querySelector('[data-review-modal-name]').textContent = card.dataset.reviewName || '';
    reviewModal.querySelector('[data-review-modal-date]').textContent = card.dataset.reviewDate || '';
    reviewModal.querySelector('[data-review-modal-text]').textContent = card.dataset.reviewText || '';
    reviewModal.hidden = false;
    document.body.classList.add('trusttap-review-open');
    reviewModal.querySelector('[data-review-close]')?.focus();
  }));
  reviewModal?.querySelectorAll('[data-review-close]').forEach(button => button.addEventListener('click', closeReview));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && reviewModal && !reviewModal.hidden) closeReview(); });
  refreshCart().catch(() => {});
}
